// extracted by css-extract-rspack-plugin
export default {"radioGroup":"NotificationSettingsDialog-module__radioGroup__ZVQ6l","checkboxGroup":"NotificationSettingsDialog-module__checkboxGroup__mLcX9"};